/** Retains the established panel and legacy booth SignalR send/create envelopes. */
export function sendChatMessage(socket, { id, boothId, text, currentUserId, beforeId = 0 }) {
  if (!socket || !text?.trim()) return false;
  if (id) {
    if (socket.sendConfirmed) return socket.sendConfirmed({ id, text, currentUserId, beforeId });
    socket.send(JSON.stringify({ arguments: [{ chatId: id, message: text }], invocationId: "0", target: "SendMessage", type: 1 }) + "\u001e");
    return true;
  }
  if (boothId) {
    socket.send(JSON.stringify({ arguments: [boothId], invocationId: "0", target: "CreateChat", type: 1 }) + "\u001e");
    return true;
  }
  return false;
}
